module.exports = __webpack_public_path__ + "static/media/ellipse.desktop.98a3540b.png";